'use client';
import Link from 'next/link';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const TextStyledLink = styled.a`
  color: ${({ theme }) => theme.colors.actionDefault};
  text-decoration: none;
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
`;

export const StyledLink = styled(Link)<{ $centered?: boolean; $withGap?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $withGap }) => ($withGap ? `${Spacers.XS}rem` : '0')};
  justify-content: ${({ $centered = true }) => ($centered ? 'center' : 'flex-start')};
  color: ${({ theme }) => theme.colors.actionDefault};
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
`;